// extracted by mini-css-extract-plugin
export default {"wrapper":"Ay-z","addressLine":"By-z","fullName":"Cy-z"};